import React, { ReactNode } from "react";
import { Container } from "./style";

interface IHeaderPageProps {
  title: ReactNode;
  subtitle: ReactNode;
  /** Botões à direita do título (redesign V3). */
  actions?: ReactNode;
}

export const PageHeader: React.FC<IHeaderPageProps> = ({ title, subtitle, actions }) => {
  return (
    <Container className="page-header">
      <div className="texts">
        <span className="title">{title}</span>
        <span className="sub-title">{subtitle}</span>
      </div>
      {actions && <div className="actions">{actions}</div>}
    </Container>
  );
};
